import { StyleSheet } from 'react-native';
import { PALETTE } from '../../constants';

export default StyleSheet.create({
  value: {
      color: "#ffffff", 
  },
  marketTotal: {
      fontSize: "20px",
      //color: "#ED6900",
      marginRight: "10px"
  },
  marketTotalNomination: {
    fontSize: 24,
    color: PALETTE.secondaryActive,
    marginRight: 7
},
marketTotalHeaderNomination: {
  color: "#ffffff",
  lineHeight: 58
},
  decimelStyle: {
    fontSize: 16,
  },
  headerDecimelStyle: {
    fontSize: 40,
  },
  marketValueText: {
    color: 'white',
    letterSpacing: 0.29,
  },
  percentStyle: {
    color: 'white', 
  }
});
